import { UserOption } from 'src/app/pages/user-register/models/user-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const userOptionActions = createEagerSelectActions<UserOption>('[User Options]');
